(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["damyaan-search-results"] && !Shopify.designMode) return;
  try {
    
// Match selected size/colour/etc. to an actual Shopify variant before cart submission.
(function(){
 function refresh(form){
  const raw=form.querySelector('[data-dsy-variants]');
  if(!raw)return;
  let variants=[];
  try{variants=JSON.parse(raw.textContent||'[]');}catch(e){return;}
  const choices=Array.from(form.querySelectorAll('[data-dsy-option-index]')).map(el=>el.value);
  const selected=variants.find(v=>choices.every((choice,i)=>v.options && v.options[i]===choice));
  const id=form.querySelector('[data-dsy-variant-id]');
  const btn=form.querySelector('[data-dsy-cart-button]');
  const error=form.querySelector('[data-dsy-variant-error]');
  if(id)id.value=selected?selected.id:'';
  if(btn){btn.disabled=!selected||!selected.available;btn.innerHTML=selected&&!selected.available?'Sold out':'<span aria-hidden="true">🛒</span> Add to cart';}
  if(error)error.hidden=!!selected;
 }
 document.addEventListener('click',e=>{
  const chip=e.target.closest('[data-dsy-chip]');
  if(chip){
    const group=chip.closest('[data-dsy-option-group]');
    const select=group?.querySelector('.dsy-option-select');
    if(!select)return;
    select.value=chip.dataset.value;
    group.querySelectorAll('[data-dsy-chip]').forEach(c=>{const on=c===chip;c.classList.toggle('is-selected',on);c.setAttribute('aria-pressed',String(on));});
    const label=group.querySelector('[data-dsy-selected-label]');if(label)label.textContent=chip.dataset.value;
    refresh(chip.closest('.dsy-variant-form'));
    return;
  }
  const qtyBtn=e.target.closest('[data-dsy-qty-change]');
  if(qtyBtn){
    const input=qtyBtn.closest('.dsy-quantity-wrap')?.querySelector('.dsy-quantity');
    if(input){const step=Number(qtyBtn.dataset.dsyQtyChange)||0;input.value=String(Math.min(99,Math.max(1,(Number(input.value)||1)+step)));}
  }
 });
 document.addEventListener('change',e=>{
  if(e.target.matches('.dsy-option-select')){
    const group=e.target.closest('[data-dsy-option-group]');
    group?.querySelectorAll('[data-dsy-chip]').forEach(c=>{const on=c.dataset.value===e.target.value;c.classList.toggle('is-selected',on);c.setAttribute('aria-pressed',String(on));});
    const label=group?.querySelector('[data-dsy-selected-label]');if(label)label.textContent=e.target.value;
    refresh(e.target.closest('.dsy-variant-form'));
  }
 });
 document.addEventListener('submit',e=>{
  const form=e.target.closest('.dsy-variant-form');
  if(!form)return;
  refresh(form);
  if(!form.querySelector('[data-dsy-variant-id]')?.value)e.preventDefault();
 },true);
 function init(root){root.querySelectorAll('.dsy-variant-form').forEach(refresh);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
 // Newly loaded cards are inserted by infinite scroll; refresh on first interaction.
 document.addEventListener('focusin',e=>{const form=e.target.closest('.dsy-variant-form');if(form)refresh(form);});
})();


function dsySyncPricePills(form) {

  const minInput = form.querySelector('.dsy-min-price');

  const maxInput = form.querySelector('.dsy-max-price');

  if (!minInput || !maxInput) return;

  form.querySelectorAll('[data-dsy-price-pill]').forEach(function(pill) {

    const minValue = minInput.value.trim() === '' ? '' : String(parseFloat(minInput.value));

    const maxValue = maxInput.value.trim() === '' ? '' : String(parseFloat(maxInput.value));

    const pillMin = pill.dataset.min === '' ? '' : String(Number(pill.dataset.min));

    const pillMax = pill.dataset.max === '' ? '' : String(Number(pill.dataset.max));

    const isSelected = pillMin === minValue && pillMax === maxValue;

    pill.classList.toggle('is-selected', isSelected);

    pill.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

  });

}

document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.dsy-price-form').forEach(dsySyncPricePills);

});

document.addEventListener('shopify:section:load', function(event) {

  event.target.querySelectorAll('.dsy-price-form').forEach(dsySyncPricePills);

});

document.addEventListener('click', function(event) {

  const pill = event.target.closest('[data-dsy-price-pill]');

  if (!pill) return;

  const form = pill.closest('.dsy-price-form');

  if (!form) return;

  form.querySelector('.dsy-min-price').value = pill.dataset.min || '';

  form.querySelector('.dsy-max-price').value = pill.dataset.max || '';

  dsySyncPricePills(form);

});

document.addEventListener('input', function(event) {

  if (!event.target.matches('.dsy-min-price, .dsy-max-price')) return;

  dsySyncPricePills(event.target.closest('.dsy-price-form'));

});

// Damyaan smart relevance ranking and progressive loading.
(function () {
  const instances = new WeakMap();
  const categories = [
    {query: /\b(food|foods|grocery|groceries|snacks?|beverages?)\b/i,
     strong: /\b(food|foods|grocery|groceries|snacks?|beverages?|rice|dal|pulses|flour|atta|masala|spices|biscuits?|chocolates?|tea|coffee|juice|noodles|pasta|cereals?|edible|cooking oil|dry fruits|namkeen|pickle|sweets|bakery)\b/i,
     weak: /\b(food|foods|grocery|snacks?|beverages?|rice|biscuits?|tea|coffee)\b/i,
     unrelated: /\b(foot|footwear|shoe|shoes|sandals?|slippers?|skincare|serum|cosmetic)\b/i},
    {query: /\b(foot|footwear|shoes?|sandals?|slippers?|sneakers?|flip[ -]?flops?)\b/i,
     strong: /\b(footwear|shoes?|sandals?|slippers?|sneakers?|flip[ -]?flops?|boots?|heels?|chappals?|loafers?)\b/i,
     weak: /\b(footwear|shoes?|sandals?|slippers?|sneakers?|flip[ -]?flops?|boots?|heels?|chappals?|loafers?)\b/i,
     unrelated: /\b(foot care|foot cream|foot scrub|foot roll|foot roller|foot mask|foot serum|urea|moisturizer|skin care|skincare|beauty|cosmetic)\b/i},
    {query: /\b(men'?s?|male|gents?)\s+(dress|clothing|wear|fashion|outfits?)\b/i,
     strong: /\b(shirts?|t[ -]?shirts?|jeans|trousers?|pants?|kurtas?|shorts?|hoodies?|jackets?|blazers?|clothing|apparel|menswear)\b/i,
     weak: /\b(shirts?|t[ -]?shirts?|jeans|trousers?|pants?|kurtas?|shorts?|hoodies?|jackets?|blazers?)\b/i,
     unrelated: /\b(watches?|perfumes?|fragrance|wallet|sunglasses|footwear|shoes?|sandals?)\b/i},
    {query: /\b(beauty|cosmetics?|skincare|skin care)\b/i,
     strong: /\b(beauty|cosmetics?|skincare|skin care|serum|makeup|lipstick|moisturizer|face wash|face cream|sunscreen|shampoo|conditioner)\b/i,
     weak: /\b(beauty|cosmetics?|skincare|skin care|serum|makeup|lipstick|moisturizer)\b/i}
  ];
  function init(root) {
    if (!root || instances.has(root)) return;
    const grid = root.querySelector('[data-dsy-results]');
    if (!grid) return;
    const panel = root.querySelector('[data-dsy-autoload]');
    const query = (root.querySelector('.dsy-input')?.value || '').trim();
    const category = categories.find(c => c.query.test(query));
    const maxCards = Number(panel?.dataset.limit) || 200;
    const loading = panel?.querySelector('[data-dsy-loading]');
    const error = panel?.querySelector('[data-dsy-error]');
    const sentinel = panel?.querySelector('[data-dsy-sentinel]');
    const nextLink = panel?.querySelector('[data-dsy-next]');
    const seen = new Set();
    let nextUrl = panel?.dataset.nextUrl || '';
    let count = 0, busy = false, stopped = false, observer = null, controller = null;
    let pageCount = 0;
    const status = document.createElement('p');
    status.className = 'dsy-smart-count';
    status.setAttribute('aria-live', 'polite');
    const heading = root.querySelector('.dsy-heading h1');
    // Keep product-count and search-matching messages hidden.

    function rank(card) {
      if (!category) return 0;
      const title = card.dataset.dsyTitle || '';
      const metadata = [card.dataset.dsyType || '', card.dataset.dsyTags || '', card.dataset.dsyCollections || ''].join(' ');
      const combined = metadata + ' ' + title;
      let score = 0;
      // Category metadata is more trustworthy than a coincidental title word.
      if (category.strong.test(metadata)) score += 100;
      if (category.weak.test(title)) score += 30;
      if (category.unrelated?.test(combined)) score -= 120;
      return score;
    }
    function reorder() {
      if (!category) return;
      const cards = Array.from(grid.querySelectorAll('[data-product-id]'));
      cards.sort((a,b) => Number(b.dataset.dsyRank) - Number(a.dataset.dsyRank));
      const fragment = document.createDocumentFragment();
      cards.forEach(card => fragment.appendChild(card));
      grid.appendChild(fragment);
    }
    function add(card, existing) {
      const id = card.dataset.productId;
      if (!id || seen.has(id)) {
        if (existing) card.remove();
        return;
      }
      seen.add(id);
      const node = existing ? card : document.importNode(card, true);
      node.dataset.dsyRank = String(rank(node));
      if (!existing) grid.appendChild(node);
      count++;
    }
    function updateStatus() {
      status.textContent = ''; 
    }
    Array.from(grid.querySelectorAll('[data-product-id]')).forEach(card => add(card,true));
    reorder();
    updateStatus();
    if (!panel) return;
    function update() {
      stopped = !nextUrl || count >= maxCards || pageCount >= 50;
      if (stopped) observer?.disconnect();
      sentinel.hidden = stopped;
      // Stop at the first complete Shopify page after ~200 items to avoid skipping products.
      nextLink.hidden = !nextUrl || (!stopped && 'IntersectionObserver' in window);
      if (nextUrl) nextLink.href = nextUrl;
    }
    async function load() {
      if (busy || stopped || !nextUrl) return;
      busy = true;
      loading.hidden = false;
      error.hidden = true;
      controller = new AbortController();
      try {
        const response = await fetch(nextUrl, {credentials:'same-origin',signal:controller.signal});
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextRoot = doc.getElementById(root.id);
        const nextGrid = nextRoot?.querySelector('[data-dsy-results]');
        if (!nextGrid) throw new Error('Products not found');
        Array.from(nextGrid.querySelectorAll('[data-product-id]')).forEach(card => add(card,false));
        nextUrl = nextRoot.querySelector('[data-dsy-autoload]')?.dataset.nextUrl || '';
        pageCount++;
        reorder();
        updateStatus();
        update();
      } catch (e) {
        if (e.name !== 'AbortError') error.hidden = false;
      } finally {
        busy = false;
        loading.hidden = true;
      }
    }
    panel.querySelector('[data-dsy-retry]')?.addEventListener('click',load);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, {rootMargin:'700px 0px'});
      observer.observe(sentinel);
    } else {
      sentinel.hidden = true;
    }
    update();
    instances.set(root,{destroy(){observer?.disconnect();controller?.abort();}});
  }
  function initAll(context) {
    if (context.matches?.('.dsy')) init(context);
    context.querySelectorAll('.dsy').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    const root = event.target.matches?.('.dsy') ? event.target : event.target.querySelector('.dsy');
    if (root && instances.has(root)) {instances.get(root).destroy();instances.delete(root);}
  });
})();


// Damyaan mobile Sort / Filters: only one panel open at a time.
document.addEventListener('toggle', function(event) {
  var tool = event.target;
  if (!tool.matches || !tool.matches('.dsy-mobile-toolbar [data-dsy-tool]') || !tool.open) return;
  var bar = tool.closest('.dsy-mobile-toolbar');
  if (!bar) return;
  bar.querySelectorAll('[data-dsy-tool]').forEach(function(other) { if (other !== tool) other.open = false; });
}, true);


// Mobile bottom sheets and Meesho-style filter category tabs.
(function(){
 function setup(root){
  if(!root || root.dataset.dsySheetReady==='1')return;
  root.dataset.dsySheetReady='1';
  var tools=root.querySelectorAll('.dsy-mobile-toolbar [data-dsy-tool]');
  tools.forEach(function(tool){
   tool.addEventListener('toggle',function(){
    if(tool.open){
     tools.forEach(function(other){if(other!==tool)other.open=false;});
     if(tool.classList.contains('dsy-filter-tool')){
      var tabs=tool.querySelectorAll('.dsy-filter-inner .dsy-facet');
      tabs.forEach(function(tab,i){tab.open=true;tab.classList.toggle('dsy-tab-active',i===0);});
     }
    }
    document.body.style.overflow=Array.from(tools).some(function(t){return t.open;})?'hidden':'';
   });
   tool.querySelectorAll('[data-dsy-close]').forEach(function(button){button.addEventListener('click',function(){tool.open=false;});});
   tool.querySelectorAll('.dsy-filter-inner .dsy-facet>summary').forEach(function(summary){
    summary.addEventListener('click',function(event){
     event.preventDefault();
     tool.querySelectorAll('.dsy-filter-inner .dsy-facet').forEach(function(tab){tab.open=true;tab.classList.toggle('dsy-tab-active',tab===summary.parentElement);});
    });
   });
  });
  document.addEventListener('keydown',function(event){if(event.key==='Escape')tools.forEach(function(tool){tool.open=false;});});
 }
 function init(context){if(context.matches&&context.matches('.dsy'))setup(context);context.querySelectorAll('.dsy').forEach(setup);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
